import {downloadGrey, enlargeIc, placeholder} from '../../assets/images/images';
import React from 'react';

const resizeImage = (id, enlarge) => {
  const img = document.getElementById(id);

  if (enlarge) {
    img.classList.remove('max-h-[292px]');
  } else {
    img.classList.add('max-h-[292px]');
  }
};

const ExpandImageToggle = ({imgUrl = placeholder, id}) => (
  <div className="absolute flex items-center gap-2 right-2 bottom-2">
    <button
      onBlur={() => resizeImage(`${id}`)}
      onClick={() => resizeImage(`${id}`, true)}
      className="flex items-start gap-2 px-2 py-2 text-xs font-medium rounded text-grey bg-white80 w-fit"
    >
      <span className="-mb-[2px]">Enlarge image</span>
      <img src={enlargeIc} alt="" className="-mt-[2px]" />
    </button>
    <a
      href={`${imgUrl}`}
      download="file"
      rel="noreferrer"
      className="flex items-start gap-2 px-2 py-2 text-xs font-medium rounded text-grey bg-white80 w-fit"
    >
      <span>Download</span>
      <img src={downloadGrey} alt="" className="-mt-[2px]" />
    </a>
  </div>
);

const RoundedImage = ({imageUrl}) => (
  <div
    style={{width: '30ch', height: '30ch', borderRadius: '50rem'}}
    className="flex items-center justify-center overflow-clip shadow-lg shadow-brandBlue4"
  >
    <img
      src={imageUrl || placeholder}
      alt="Liveness Image"
      className="h-full w-auto object-cover object-center"
    />
  </div>
);

export {ExpandImageToggle, RoundedImage, resizeImage};
